import {makeAutoObservable} from "mobx";

export class CustomerStorage {
    CUSTOMERS = 'marketplace-customers';
    CUSTOMER = 'marketplace-customer'
    constructor(storage) {
        this._storage = storage;
        this._customers = this._storage.get(this.CUSTOMERS) || null;
        this._customer = this._storage.get(this.CUSTOMER) || JSON.stringify(this.getCustomers().length > 0 ? this.getCustomers()[0] : null);
        makeAutoObservable(this);
    }

    addCustomers(customers) {
        this._customers = JSON.stringify(customers);
        this._storage.add(this.CUSTOMERS, this._customers);
    }

    addCustomer(customer){
        this._customer = JSON.stringify(customer)
        this._storage.add(this.CUSTOMER, (this._customer));
    }

    hasCustomer(){
        return this.getCustomer() !== null
    }

    removeCustomers(){
        this._customers = undefined
        this._storage.remove(this.CUSTOMERS)
    }

    getCustomers(){
        this._customers = this._storage.get(this.CUSTOMERS);
        return JSON.parse(this._customers) || []
    }

    getCustomer() {
        if(this._customer === null) {
            this._customer = this.getCustomers() && JSON.stringify(this.getCustomers().length > 0 ? this.getCustomers()[0] : null);
        }
        return JSON.parse(this._customer)
    }
}
